(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AgenciasController', AgenciasController)
 
    AgenciasController.$inject = ["AgenciasService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AgenciasController(AgenciasService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.agencias = []; 
        vm.dias = []; 
		vm.generalLab = GenerallabService;
		vm.agenciaRecomendada = {};
        vm.init = function(grupo_id){
        	vm.grupo_id = grupo_id;
	        AgenciasService.getAgencias(function(data){
	        	//console.log(data);
	        	vm.agencias = data.agencias;
	        	vm.dias = data.dias;
	        })
	    }

	    vm.addDia = function(agencia,dia){
	    	if(typeof(agencia.horario[dia])=='undefined'){
	    		agencia.horario[dia] = [];
	    	}
	    	agencia.horario[dia].push({});
	    	//console.log(agencia);
	    }
    	
    	vm.addHorario = function(agencia){
    		agencia.horario = {
    			'0':[],
    			'1':[],
    			'2':[],
    			'3':[],
    			'4':[],
    			'5':[],
    			'6':[]
    		};
    	}

    	vm.borrarHorario = function(horario,index){
    		horario[index].borrado = 1;
    	}

    	vm.guardar = function(){
    		AgenciasService.guardar(vm.agencias,function(data){
	        	vm.agencias = data.agencias;
	        	//console.log(data);
	        	//vm.agencias = data.agencias;
	        })
    	}
    }
  
})();